import MultiempresaService from "@/services/MultiempresaService";

export const multiempresa = {
  namespaced: true,
  state: {
    grupos: [],
  },
  actions: {
    getGrupos({ commit }) {
      return MultiempresaService.GetGrupos().then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    saveGrupo({ commit }, payload) {
      return MultiempresaService.SaveGrupo(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    deleteGrupo({ commit }, payload) {
      return MultiempresaService.DeleteGrupo(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    getLogs({ commit }, payload) {
      return MultiempresaService.GetLogs(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    reprocessar({ commit }, payload) {
      return MultiempresaService.Reprocessar(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    getEmpresasPermitidas({ commit }) {
      return MultiempresaService.GetEmpresasPermitidas().then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    getUsuariosGrupo({ commit }, payload) {
      return MultiempresaService.GetUsuariosGrupo(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    getReceberConsolidado({ commit }, payload) {
      return MultiempresaService.GetReceberConsolidado(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    getPagarConsolidado({ commit }, payload) {
      return MultiempresaService.GetPagarConsolidado(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    getPedidosConsolidado({ commit }, payload) {
      return MultiempresaService.GetPedidosConsolidado(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    getEstoqueConsolidado({ commit }, payload) {
      return MultiempresaService.GetEstoqueConsolidado(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    getResumo({ commit }, payload) {
      return MultiempresaService.GetResumo(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    getDashboard({ commit }, payload) {
      return MultiempresaService.GetDashboard(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    getDre({ commit }, payload) {
      return MultiempresaService.GetDre(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    getVendas({ commit }, payload) {
      return MultiempresaService.GetVendas(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    getProdutosServicos({ commit }, payload) {
      return MultiempresaService.GetProdutosServicos(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    getFluxoCaixa({ commit }, payload) {
      return MultiempresaService.GetFluxoCaixa(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    getInadimplencia({ commit }, payload) {
      return MultiempresaService.GetInadimplencia(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    getCurvaABC({ commit }, payload) {
      return MultiempresaService.GetCurvaABC(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
  },
  mutations: {},
};

export default multiempresa;
